import {
    map,
    share,
    switchMap,
    withLatestFrom,
} from 'rxjs/operators';
import {
    Subject,
    of,
} from 'rxjs';

import createServiceResponseStream from './createServiceResponseStream';
import defaultServiceProxy from '../../Shared/Utils/mapDataToCamelCase';

const serviceUrlMapper = (serviceType, [requestData, latestConfig]) => ({
    requestData,
    serviceUrl: latestConfig.serviceUrls[serviceType],
});

const createService = (
    serviceType,
    configStoreUpdate$,
    serviceRequest,
    handleServiceError,
    retries,
    interceptResponseWithStream = response => of(response),
    serviceProxy = defaultServiceProxy,
) => {
    const mapRequestToServiceUrl = serviceUrlMapper.bind(null, serviceType);

    const request$ = new Subject();

    const response$ = request$
        .pipe(
            withLatestFrom(configStoreUpdate$),
            map(mapRequestToServiceUrl),
            switchMap(({ requestData, serviceUrl }) =>
                createServiceResponseStream(
                    serviceUrl,
                    serviceRequest,
                    serviceProxy,
                    requestData,
                    handleServiceError,
                    retries,
                )
            ),
            switchMap(interceptResponseWithStream),
            share(),
        );

    return {
        request$,
        response$,
    };
};

export default createService;
